import Vue from "vue";
import "./bootstrap";
import App from "./App.vue";
import router from "./router";
import store from "./store/store";
import { isLoggedIn } from "./config/auth";
import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import VueRouter from "vue-router";

// import axios from 'axios'
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import "vue-multiselect/dist/vue-multiselect.min.css";
import VuePaginate from "vue-paginate";
import "vuetify/dist/vuetify.min.css";
import Vuetify from "vuetify";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faUserSecret } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import Multiselect from "vue-multiselect";
import VueDraggable from "vue-draggable";
import VueBarcode from "vue-barcode";
import CanvasJSChart from '@canvasjs/vue-charts';
import VueMeta from 'vue-meta';

// GOOGLE
import VueGapi from "vue-gapi";

library.add(faUserSecret);

Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.component("multiselect", Multiselect);

// window.axios = axios
// window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
// window.axios.defaults.baseURL = process.env.VUE_APP_URL

// Vue.prototype.$axios = axios;

Vue.use(CanvasJSChart);
Vue.use(VueBarcode);
Vue.use(VueRouter);
Vue.use(VueSweetalert2);
Vue.use(VuePaginate);
Vue.use(VueDraggable);
Vue.use(Multiselect);
Vue.use(Vuetify);
Vue.use(VueMeta);


Vue.use(VueGapi, {
  clientId: "65945898773-sqkg4q7mgf7333d27mddeet76qu99l3t.apps.googleusercontent.com",
  scope: "profile email",
  prompt: "select_account",
});

Vue.config.productionTip = false;

router.beforeEach((to, from, next) => {
  if (!to.matched.some(record => record.meta.isPublic) && !isLoggedIn()) {
    next({
      name: 'NotFound',
      params: {
        pathMatch: to.path.split('/').slice(1)
      },
      query: {
        redirect: to.fullPath
      }
    });

    return;
  }

  const nearestWithMeta = to.matched
    .slice()
    .reverse()
    .find(record => record.meta && record.meta.title);

  if (nearestWithMeta) {
    const meta = nearestWithMeta.meta;

    document.title = meta.title || 'Havoline Moto Club';

    const descriptionTag = document.querySelector(
      'meta[name="description"]'
    );

    if (descriptionTag && meta.description) {
      descriptionTag.setAttribute(
        'content',
        meta.description
      );
    }

    let canonicalTag = document.querySelector(
      'link[rel="canonical"]'
    );

    if (!canonicalTag) {
      canonicalTag = document.createElement('link');
      canonicalTag.setAttribute('rel', 'canonical');
      document.head.appendChild(canonicalTag);
    }

    const baseUrl = 'https://havolinemotoclub.com';

    const canonicalPath = meta.canonical
      ? meta.canonical
      : to.fullPath;

    canonicalTag.setAttribute(
      'href',
      `${baseUrl}${canonicalPath}`
    );
  } else {
    document.title = 'Havoline Moto Club';
  }

  next();
});

new Vue({
  store,
  router,
  vuetify: new Vuetify(),
  render: h => h(App)
}).$mount("#app");
